export function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div>
      <p className="text-[13px] uppercase tracking-wider text-muted-foreground font-medium mb-2.5">
        {label}
      </p>
      {children}
    </div>
  );
}
